import { includes } from 'lodash'

/**
 * Resolves the public website base URL for deep links (car detail, search).
 * Mirrors logic in Cars.jsx.
 */
export default function getFrontendBaseUrl(location = null) {
  const pathname = location?.pathname || (typeof window !== 'undefined' ? window.location.pathname : '')
  const search = location?.search || (typeof window !== 'undefined' ? window.location.search : '')
  const searchParams = new URLSearchParams(search)

  if (includes(pathname, 'dashboard-dev') || searchParams.has('dashboard-dev')) {
    return 'https://uat.ajarlee.om'
  }

  if (includes(pathname, 'dashboard') || searchParams.has('dashboard')) {
    return 'https://www.ajarlee.om'
  }

  return process.env.REACT_APP_FRONTEND_HOST_URL || 'https://www.ajarlee.om'
}
